import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const slashid = defineConnector({
  identifier: "slashid",
  name: "SlashID",
  tagLine: "Identity and authentication",
  logo,
  protocol: "http",
  tags: ["identity"],
  defaultUrlPattern: () => "https://api\\.slashid\\.com/.*",
  auth: (app) =>
    headerAuth([
      { name: "SlashID-API-Key", value: app.secret.apiKey },
      { name: "SlashID-OrgID", value: app.config.orgId },
    ]),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In the SlashID console, navigate to **Settings → API Keys** and create a new key. Also note your Organization ID.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
        {
          kind: "input",
          label: "Organization ID",
          required: true,
          target: { kind: "configuration", field: "orgId" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.slashid.com/organizations",
  },
});
